// Central place for SPA routes and API endpoints.
// For dev vs prod you only need to change `REACT_APP_API_URL`
// in your `.env` before building:
//   - Dev (emulators):  http://localhost:5001/<project>/us-central1/api
//   - Prod (deployed):  https://<region>-<project>.cloudfunctions.net/api
export const urlConfig = {
	pages: {
		main: '/',
		login: '/login',
		register: '/register',
		addPost: '/add-post',
		post: '/post/:id',
		postWithAddress: '/post/:id/:address',
		updatePost: '/post/update/:id',
		postPhotos: '/post/photos/:id',
		admin: '/admin',
	},
	api: {
		login: '/auth/login',
		register: '/auth/register',
		getPosts: '/posts',
		post: '/posts/:id',
		createPost: '/posts/create',
		updatePost: '/posts/update',
		approvePost: '/posts/approve',
		createPhoto: '/posts/create/photo',
		photos: '/posts/photos/:id',
		adminUsers: '/users/admin/:id',
		updateUser: '/users/:id',
		deleteUser: '/users/:id',
	},
	API_URL: process.env.REACT_APP_API_URL as string,
};
